/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import get from 'lodash/get';
import {
    GET_LOOKUP,
    GET_LOOKUP_ERROR,
    GET_HOLIDAYS,
    GET_HOLIDAYS_ERROR,
} from '../constants';

const INITIALSTATE = {};

const lookup = (state = INITIALSTATE, action) => {
    const st = { ...state };
    let lookupId;
    switch (action.type) {
        case GET_LOOKUP:
            if (action.payload) {
                lookupId = action.payload.lookup_id;
                st[lookupId] = { results: action.payload.data, isValid: true };
            }
            return st;
        case GET_LOOKUP_ERROR:
            if (action.error) {
                lookupId = action.error.lookup_id;
                st[lookupId] = { error: action.error.err, results: {}, isValid: false };
            }
            return st;
        case GET_HOLIDAYS:
            st.holidays = { results: action.payload, isValid: true };
            return st;
        case GET_HOLIDAYS_ERROR:
            st.holidays = {
                error: get(action, 'error.err', 'Error fetching holiday schedule.'),
                results: {},
                isValid: false,
            };
            return st;

        default:
            return st;
    }
};

export default lookup;
